<template>
  <div>
    <v-container v-if="pageLoading" grid-list-xl text-xs-center>
        <v-layout>
            <v-flex>
                <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
                ></v-progress-circular>
            </v-flex>
        </v-layout>
    </v-container>
    <div>
      <v-toolbar flat color="white">
        <v-toolbar-title>Registros RFI Empleados</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="uploadWizard = true; dataExcel = []; wizard = 0;">
          <span class="material-icons mr-2">library_add</span> Subir registros</v-btn>
      </v-toolbar>
      <v-container fluid class="pa-0 pt-2">
        <v-layout row wrap >
          <v-data-table
            :headers="headers"
            :items="documents"
            :search="search"
            :loading="isLoading"
            :items-per-page="10"
            :rows-per-page-text="$t('datatable.rowsPerPageText')"
            :no-results-text="$t('datatable.noResultsText')"
            :no-data-text="$t('datatable.noDataText')"
            :rows-per-page-items="[10,20,50,100,{'text':$t('datatable.allRowsPerPageItems'),'value':-1}]"
            class="table-striped mt-2 elevation-2"
            dense
            style="width: 100%"
          >
            <template slot="items" slot-scope="props">
              <tr>
                <td><a class="text-decoration-underline" @click="handleRow(props.item, 'edit')">{{ props.item.id }}</a></td>
                <td>{{ props.item.batch_number }}</td>
                <td>{{ props.item.employee_id_number }}</td>
                <td>{{ props.item.employee_id_type }}</td>
                <td>{{ props.item.current_year }}</td>
                <td>{{ props.item.next_year }}</td>
                <td>{{ props.item.title }}</td>
                <td>{{ props.item.employee_name }}</td>
                <td>{{ props.item.employee_last_name }}</td>
                <td>{{ props.item.employee_email }}</td>
                <td>{{ props.item.employee_position }}</td>
                <td>{{ props.item.commitment }}</td>
                <td>{{ props.item.current_fv_commitment }}</td>
                <td>{{ props.item.employee_salary }}</td>
                <td>{{ props.item.bonus_text }}</td>
                <td>{{ props.item.current_bonus }}</td>
                <td>{{ props.item.increase }}</td>
                <td>{{ props.item.pending_adjustments }}</td>
                <td>{{ props.item.new_bonus }}</td>
                <td>{{ props.item.taxes }}</td>
                <td>{{ props.item.housing }}</td>
                <td>{{ props.item.visa }}</td>
                <td>{{ props.item.visa_expire_date }}</td>
                <td>{{ props.item.insurance_text }}</td>
                <td>{{ props.item.health_insurance_for }}</td>
                <td>{{ props.item.insurance_company }}</td>
                <td>{{ props.item.ticket_pass_for }}</td>
                <td>{{ props.item.destination_city }}</td>
                <td>{{ props.item.scholarship_text }}</td>
                <td>{{ props.item.scholarship_percentage }}</td>
                <td>{{ props.item.scholarship_benefit_for }}</td>
                <td>{{ props.item.bonus_pd }}</td>
                <td>{{ props.item.additional_text_1 }}</td>
                <td>{{ props.item.additional_text_2 }}</td>
                <td style="overflow: auto;"><div style="width: 380px">{{ props.item.additional_text_3 }}</div></td>
                <td>{{ props.item.additional_value_1 }}</td>
                <td>{{ props.item.additional_value_2 }}</td>
                <td>{{ props.item.additional_value_3 }}</td>
                <td>{{ props.item.additional_value_4 }}</td>
                <td>{{ props.item.additional_value_5 }}</td>
                <td>{{ props.item.additional_value_6 }}</td>
                <td>{{ props.item.employee_rowid }}</td>
                <td>
                  <v-tooltip top>
                    <v-icon
                      medium
                      class="mr-2"
                      @click="handleRow(props.item, 'edit')"
                      slot="activator"
                      color="orange"
                    >
                      edit
                    </v-icon>
                    <span>Editar</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <v-icon
                      medium
                      class="mr-2"
                      @click="handleRow(props.item, 'delete')"
                      slot="activator"
                      color="red"
                    >
                      delete
                    </v-icon>
                    <span>Eliminar</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
            <template v-slot:no-results>
              Su búsqueda para <b>"{{ search }}"</b> no obtuvo resultados.
            </template>
            <template v-slot:pageText="props">
              {{ props.pageStart }} - {{ props.pageStop }} {{ $t('datatable.pageTextOf') }} {{ props.itemsLength }}
            </template>
          </v-data-table>
        </v-layout>
      </v-container>
      <v-dialog
          v-model="uploadWizard"
          max-width="1010"
        >
        <v-card> 
          <v-card-title class="title">
            Subir registros
          </v-card-title>
          <v-tabs v-model="wizard" align-left slider-color="accent" md12 lg12 xl12 class="elevation-2" >
            <v-tab key="step1">Paso 1</v-tab>
            <v-tab key="step2" :disabled="!batchNumber || dataExcel.length == 0">Paso 2</v-tab>
            <v-tab-item key="step1">
              <v-card class="pa-2">
                <v-text-field v-model="batchNumber" label="Número de lote" hint="Formato AAAAMM" :rules="[ value => !!value || 'Requerido', value => /^\d{4}(0?[1-9]|1[012])$/.test(value) || 'Formato AAAAMM']" ></v-text-field>
                <FileUpload
                  id="upload"
                  v-model="files"
                  name="files[]"
                  class="v-btn theme--dark primary"
                  extensions="xlsx,xls"
                  accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  :multiple="false"
                  :size="1024 * 1024 * 10"
                  @input-file="inputFile"
                  ref="upload">
                  <span class="material-icons mr-2 mt-1">upload_file</span> Subir XLSX
                </FileUpload>
                <a :href="`${appUrl}/utils/employee_information_sign_demo.xlsx`" target="_blank">Muestra .xlsx</a>
                <span v-if="dataExcel && dataExcel.length > 0" class="grey-text">{{ dataExcel.length }} registros leídos</span>
              </v-card>
            </v-tab-item>
            <v-tab-item key="step2" class="pa-2">
              <v-data-table
                :headers="headers.filter( x => x.value != 'id')"
                :items="dataExcel"
                :search="search"
                :loading="isLoading"
                :items-per-page="5"
                :rows-per-page-text="$t('datatable.rowsPerPageText')"
                :no-results-text="$t('datatable.noResultsText')"
                :no-data-text="$t('datatable.noDataText')"
                :rows-per-page-items="[5,10,20,50,{'text':$t('datatable.allRowsPerPageItems'),'value':-1}]"
                class="table-striped mt-2"
                dense
                style="width: 100%"
              >
                <template slot="items" slot-scope="props">
                  <tr :class="{'error': props.item.row_class }">
                    <td>{{ props.item.employee_id_number }}</td>
                    <td>{{ props.item.employee_id_type }}</td>
                    <td>{{ props.item.current_year }}</td>
                    <td>{{ props.item.next_year }}</td>
                    <td>{{ props.item.title }}</td>
                    <td>{{ props.item.employee_name }}</td>
                    <td>{{ props.item.employee_last_name }}</td>
                    <td>{{ props.item.employee_email }}</td>
                    <td>{{ props.item.employee_position }}</td>
                    <td>{{ props.item.commitment }}</td>
                    <td>{{ props.item.current_fv_commitment }}</td>
                    <td>{{ props.item.employee_salary }}</td>
                    <td>{{ props.item.bonus_text }}</td>
                    <td>{{ props.item.current_bonus }}</td>
                    <td>{{ props.item.increase }}</td>
                    <td>{{ props.item.pending_adjustments }}</td>
                    <td>{{ props.item.new_bonus }}</td>
                    <td>{{ props.item.taxes }}</td>
                    <td>{{ props.item.housing }}</td>
                    <td>{{ props.item.visa }}</td>
                    <td>{{ props.item.visa_expire_date }}</td>
                    <td>{{ props.item.insurance_text }}</td>
                    <td>{{ props.item.health_insurance_for }}</td>
                    <td>{{ props.item.insurance_company }}</td>
                    <td>{{ props.item.ticket_pass_for }}</td>
                    <td>{{ props.item.destination_city }}</td>
                    <td>{{ props.item.scholarship_text }}</td>
                    <td>{{ props.item.scholarship_percentage }}</td>
                    <td>{{ props.item.scholarship_benefit_for }}</td>
                    <td>{{ props.item.bonus_pd }}</td>
                    <td>{{ props.item.additional_text_1 }}</td>
                    <td>{{ props.item.additional_text_2 }}</td>
                    <td style="overflow: auto;"><div style="width: 380px">{{ props.item.additional_text_3 }}</div></td>
                    <td>{{ props.item.additional_value_1 }}</td>
                    <td>{{ props.item.additional_value_2 }}</td>
                    <td>{{ props.item.additional_value_3 }}</td>
                    <td>{{ props.item.additional_value_4 }}</td>
                    <td>{{ props.item.additional_value_5 }}</td>
                    <td>{{ props.item.additional_value_6 }}</td>
                    <td>{{ props.item.employee_rowid }}</td>
                  </tr>
                </template>
                <template v-slot:no-results>
                  Su búsqueda para <b>"{{ search }}"</b> no obtuvo resultados.
                </template>
                <template v-slot:pageText="props">
                  {{ props.pageStart }} - {{ props.pageStop }} {{ $t('datatable.pageTextOf') }} {{ props.itemsLength }}
                </template>
              </v-data-table>
              <v-btn color="success white--text" 
                v-if="dataExcel.length >0" 
                :disabled="fileErrors > 0"
                @click="process">
                <span class="material-icons mr-2">backup</span> Subir {{ dataExcel.length }} registros
              </v-btn>
              <span v-if="fileErrors" class="red--text text--darken-2">{{ fileErrors }} errores en el archivo, verifique</span>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="editDeleteItemDialog"
        max-width="450"
        >
        <v-card v-if="Object.keys(editDeleteItem).length > 0">
          <v-card-title class="title">
            {{ editDeleteAction == 'edit' ? 'Editar' : 'Eliminar' }} - ID {{ editDeleteItem.id }}
          </v-card-title>
          <table width="100%" class="pa-2">
            <tr><td><v-text-field v-model="editDeleteItem.batch_number" :rules="[ value => !!value || 'Requerido', value => /^\d{4}(0?[1-9]|1[012])$/.test(value) || 'Formato AAAAMM']" label="#Lote" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.employee_id_number" :rules="[ value => !!value || 'Requerido']" label="Employee Id Number" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.employee_id_type" :rules="[ value => !!value || 'Requerido']" label="Employee Id Type" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.current_year" label="Current Year" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.next_year" label="Next Year" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.title" :rules="[ value => !!value || 'Requerido']" label="Title" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.employee_name" :rules="[ value => !!value || 'Requerido']" label="Employee Name" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.employee_last_name" :rules="[ value => !!value || 'Requerido']" label="Employee Last Name" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.employee_email" :rules="[ value => !!value || 'Requerido']"  label="Employee Email" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.employee_position" :rules="[ value => !!value || 'Requerido']" label="Employee Position" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.commitment" label="Commitment" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.current_fv_commitment" label="Current Fv Commitment" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.employee_salary" label="Employee Salary" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.bonus_text" label="Bonus Text" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.current_bonus" label="Current Bonus" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.increase" label="Increase" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.pending_adjustments" label="Pending Adjustments" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.new_bonus" label="New Bonus" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.taxes" label="Taxes" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.housing" label="Housing" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.visa" label="Visa" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.visa_expire_date" label="Visa Expire Date" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.insurance_text" label="Insurance Text" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.health_insurance_for" label="Health Insurance For" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.insurance_company" label="Insurance Company" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.ticket_pass_for" label="Ticket Pass For" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.destination_city" label="Destination City" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.scholarship_text" label="Scholarship Text" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.scholarship_percentage" label="Scholarship Percentage" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.scholarship_benefit_for" label="Scholarship Benefit For" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.bonus_pd" label="Bonus Pd" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.additional_text_1" label="Additional Text 1" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.additional_text_2" label="Additional Text 2" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.additional_text_3" label="Additional Text 3" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.additional_value_1" label="Additional Value 1" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.additional_value_2" label="Additional Value 2" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.additional_value_3" label="Additional Value 3" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.additional_value_4" label="Additional Value 4" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.additional_value_5" label="Additional Value 5" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.additional_value_6" label="Additional Value 6" :readonly="editDeleteAction == 'delete'" /></td></tr>
            <tr><td><v-text-field v-model="editDeleteItem.employee_rowid" :rules="[ value => !!value || 'Requerido']"  label="Employee Rowid" :readonly="editDeleteAction == 'delete'" /></td></tr>
          </table>
          <v-btn :color="`${editDeleteAction == 'edit' ? 'orange' : 'red'} white--text`" 
            :disabled="!editDeleteItem.employee_rowid || !editDeleteItem.employee_id_number || !editDeleteItem.employee_id_type || 
                !editDeleteItem.title || !editDeleteItem.employee_name || !editDeleteItem.employee_last_name || !editDeleteItem.employee_email ||
                !editDeleteItem.employee_position"
            @click="save">
            <span class="material-icons mr-2">{{ editDeleteAction == 'edit' ? 'create' : 'delete' }}</span> {{ editDeleteAction == 'edit' ? 'Editar' : 'Eliminar' }} registro
          </v-btn>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import XLSX from 'xlsx'
  import FileUpload from 'vue-upload-component'
  var today = new Date();
  var yyyy = today.getFullYear();
  var mm = ((today.getMonth() + 1)+'').padStart(2,"00"); //January is 0!
  
  export default {
    name: 'documents-employee-view',
    components: {
      FileUpload
    },
    data() {

      return {
        appUrl: window.config.appUrl,
        documents: [],
        isLoading: false,
        pageLoading: false,
        search: '',
        headers: [
          { value: 'id', text: 'Id' },
          { value: 'batch_number', text: '#Lote' },
          { value: 'employee_id_number', text: 'Employee Id Number' },
          { value: 'employee_id_type', text: 'Employee Id Type' },
          { value: 'current_year', text: 'Current Year' },
          { value: 'next_year', text: 'Next Year' },
          { value: 'title', text: 'Title' },
          { value: 'employee_name', text: 'Employee Name' },
          { value: 'employee_last_name', text: 'Employee Last Name' },
          { value: 'employee_email', text: 'Employee Email' },
          { value: 'employee_position', text: 'Employee Position' },
          { value: 'commitment', text: 'Commitment' },
          { value: 'current_fv_commitment', text: 'Current Fv Commitment' },
          { value: 'employee_salary', text: 'Employee Salary' },
          { value: 'bonus_text', text: 'Bonus Text' },
          { value: 'current_bonus', text: 'Current Bonus' },
          { value: 'increase', text: 'Increase' },
          { value: 'pending_adjustments', text: 'Pending Adjustments' },
          { value: 'new_bonus', text: 'New Bonus' },
          { value: 'taxes', text: 'Taxes' },
          { value: 'housing', text: 'Housing' },
          { value: 'visa', text: 'Visa' },
          { value: 'visa_expire_date', text: 'Visa Expire Date' },
          { value: 'insurance_text', text: 'Insurance Text' },
          { value: 'health_insurance_for', text: 'Health Insurance For' },
          { value: 'insurance_company', text: 'Insurance Company' },
          { value: 'ticket_pass_for', text: 'Ticket Pass For' },
          { value: 'destination_city', text: 'Destination City' },
          { value: 'scholarship_text', text: 'Scholarship Text' },
          { value: 'scholarship_percentage', text: 'Scholarship Percentage' },
          { value: 'scholarship_benefit_for', text: 'Scholarship Benefit For' },
          { value: 'bonus_pd', text: 'Bonus Pd' },
          { value: 'additional_text_1', text: 'Additional Text 1' },
          { value: 'additional_text_2', text: 'Additional Text 2' },
          { value: 'additional_text_3', text: 'Additional Text 3' },
          { value: 'additional_value_1', text: 'Additional Value 1' },
          { value: 'additional_value_2', text: 'Additional Value 2' },
          { value: 'additional_value_3', text: 'Additional Value 3' },
          { value: 'additional_value_4', text: 'Additional Value 4' },
          { value: 'additional_value_5', text: 'Additional Value 5' },
          { value: 'additional_value_6', text: 'Additional Value 6' },
          { value: 'employee_rowid', text: 'Employee Rowid' },
          { value: '', text: 'Acciones', align: 'center' }
        ],
        wizard: null,
        batchNumber: yyyy+mm,
        dataExcel: [],
        files: [],
        uploadWizard: false,
        fileErrors: false,
        editDeleteItem: {},
        editDeleteAction: 'edit',
        editDeleteItemDialog: false,
      }
    },
    computed: {
      
    },
    created () {
      this.init();
    },
    methods: {
      init() {
        axios.get('api/documents/employee/rfi')
          .then(resp => {
            if (resp.status === 200) {
              this.documents = resp.data.documents
              this.pageLoading = false
            }
          })
          .then(err => {
            this.pageLoading = false
          })
      },
      ExcelToJSON ()  {
        this.parseExcel = (file)=> {
          let reader = new FileReader();

          reader.onload = (e)=> {
            let data = e.target.result;
            let workbook = XLSX.read(data, {
                type: 'binary'
            });
            workbook.SheetNames.forEach(function(sheetName) {
                // Here is your object
                let XL_row_object = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);
                let json_object = JSON.stringify(XL_row_object);
                localStorage.setItem("dataExcelSchedule", JSON.stringify(XL_row_object));
            })
          };
          reader.onerror = function(ex) {
            console.log(ex);
          };

          reader.readAsBinaryString(file);
        };
      },
      handleFileSelect(file) {
        localStorage.removeItem("dataExcelSchedule");
        var xl2json = new this.ExcelToJSON();
        xl2json.parseExcel(file);
        setTimeout(() => {
          this.getUpLoadFile()
        }, 1500);
      },
      getUpLoadFile(){
        this.fileErrors = 0
        this.dataExcel = JSON.parse(localStorage.getItem("dataExcelSchedule")).map(obj=>{
            var row_class = "";
            if (!obj.employee_rowid || !obj.employee_id_number || !obj.employee_id_type || 
                !obj.title || !obj.employee_name || !obj.employee_last_name || !obj.employee_email ||
                !obj.employee_position){
                row_class = "error"
                this.fileErrors += 1
            }
            return {
                row_class: row_class,
                employee_id_number: obj.employee_id_number || "FALTANTE",
                employee_id_type: obj.employee_id_type || "FALTANTE",
                current_year: obj.current_year || '',
                next_year: obj.next_year || '',
                title: obj.title || "FALTANTE",
                employee_name: obj.employee_name || "FALTANTE",
                employee_last_name: obj.employee_last_name || "FALTANTE",
                employee_email: obj.employee_email || "FALTANTE",
                employee_position: obj.employee_position || "FALTANTE",
                commitment: obj.commitment || '',
                current_fv_commitment: obj.current_fv_commitment || '',
                employee_salary: obj.employee_salary || '',
                bonus_text: obj.bonus_text || '',
                current_bonus: obj.current_bonus || '',
                increase: obj.increase || '',
                pending_adjustments: obj.pending_adjustments || '',
                new_bonus: obj.new_bonus || '',
                taxes: obj.taxes || '',
                housing: obj.housing || '',
                visa: obj.visa || '',
                visa_expire_date: obj.visa_expire_date || '',
                insurance_text: obj.insurance_text || '',
                health_insurance_for: obj.health_insurance_for || '',
                insurance_company: obj.insurance_company || '',
                ticket_pass_for: obj.ticket_pass_for || '',
                destination_city: obj.destination_city || '',
                scholarship_text: obj.scholarship_text || '',
                scholarship_percentage: obj.scholarship_percentage || '',
                scholarship_benefit_for: obj.scholarship_benefit_for || '',
                bonus_pd: obj.bonus_pd || '',
                additional_text_1: obj.additional_text_1 || '',
                additional_text_2: obj.additional_text_2 || '',
                additional_text_3: obj.additional_text_3 || '',
                additional_value_1: obj.additional_value_1 || '',
                additional_value_2: obj.additional_value_2 || '',
                additional_value_3: obj.additional_value_3 || '',
                additional_value_4: obj.additional_value_4 || '',
                additional_value_5: obj.additional_value_5 || '',
                additional_value_6: obj.additional_value_6 || '',
                employee_rowid: obj.employee_rowid || "FALTANTE",
                batch_number: this.batchNumber
            }
        });
      },
      inputFile(newFile, oldFile) {
        if (newFile && !oldFile) {
          this.handleFileSelect(newFile.file)
        }
        if (newFile && oldFile) {
          this.handleFileSelect(newFile.file)
        }
        if (!newFile && oldFile) {
          this.dataExcel = []
        }
      },
      handleRow(item, action) {
        this.editDeleteItem = item
        this.editDeleteAction = action
        this.editDeleteItemDialog = true
      },
      save() {
        if (this.editDeleteAction == 'edit'){
          axios.put("/api/documents/employee/rfi", { data: this.editDeleteItem })
            .then(resp=>{
              this.$store.dispatch('responseMessage', { type: 'success', text:  `Registro actualizado correctamente` })
              this.editDeleteItem = {}
              this.editDeleteItemDialog = false
              this.init()
            }).catch(error=>{
              this.$store.dispatch('responseMessage', { type: 'error', text:  `Ocurrió un error, reintente nuevamente` })
              console.error(error)
            })
        } else if(this.editDeleteAction == 'delete'){
          axios.delete("/api/documents/employee/rfi/"+this.editDeleteItem.id)
            .then(resp=>{
              this.$store.dispatch('responseMessage', { type: 'success', text:  `Registro eliminado correctamente` })
              this.editDeleteItem = {}
              this.editDeleteItemDialog = false
              this.init()
            }).catch(error=>{
              this.$store.dispatch('responseMessage', { type: 'error', text:  `Ocurrió un error, reintente nuevamente` })
              console.error(error)
            })
        }        
      },
      process(){
        axios.post("/api/documents/employee/rfi", { data: this.dataExcel })
          .then(resp=>{
            console.log(resp)
            if (resp.data.status === 200){
              this.$store.dispatch('responseMessage', { type: 'success', text:  `${this.dataExcel.length} registros subidos correctamente` })
              this.dataExcel = []
              this.uploadWizard = false
              this.init()
            } else {
              this.$store.dispatch('responseMessage', { type: 'error', text:  `Ocurrió un error, reintente nuevamente (${resp.data.data})` })
            }
          }).catch(error=>{
            this.$store.dispatch('responseMessage', { type: 'error', text:  `Ocurrió un error, reintente nuevamente (${error.response.data})` })
            console.log(error)
          })
      },
    },
  }
</script>

<style lang="scss">
  .v-datatable.v-table tbody tr:nth-of-type(odd) {
    background-color: rgba(0,0,0,.03);
  }
  .v-datatable.v-table .width-200 {
    width: 200px !important;
  }
  tr.error td {
    background-color: #ffd1d1;
    color: #790000;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/documents/employees_rfi.vue